// extracted by mini-css-extract-plugin
export default {"GitStatusBadge":"GitStatusBadge_GitStatusBadge__PVkIa","SUCCESS":"GitStatusBadge_SUCCESS__bjtPY","ERROR":"GitStatusBadge_ERROR__4LbZt","PENDING":"GitStatusBadge_PENDING__WKrlk"};